






/// reference types="dropzone"
import {Vue, Component, Prop} from 'vue-property-decorator'
import Dropzone from "dropzone"

@Component({name: 'DZ'})
export default class DZ extends Vue {

  @Prop({
    type: String,
    required: true,
  }) readonly id!: string
  @Prop({
    type: String,
    required: true,
  }) readonly url!: string
  @Prop({
    type: Boolean,
    default: true,
  }) readonly clickable!: boolean
  @Prop({
    type: String,
  }) readonly acceptedFileTypes!: string
  @Prop({
    type: Number,
    default: 200,
  }) readonly thumbnailHeight!: number
  @Prop({
    type: Number,
    default: 200,
  }) readonly thumbnailWidth!: number
  @Prop({
    type: Boolean,
    default: true,
  }) readonly showRemoveLink!: boolean
  @Prop({
    type: Number,
    default: 40,
  }) readonly maxFileSizeInMB!: number
  @Prop({
    type: Number,
    default: 10,
  }) readonly maxNumberOfFiles!: number
  @Prop({
    type: Boolean,
    default: true,
  }) readonly autoProcessQueue!: boolean
  @Prop({
    type: Boolean,
    default: false,
  }) readonly useFontAwesome!: boolean
  @Prop({
    type: Object,
  }) readonly headers: any
  @Prop({
    type: Object,
    default: () => {
      return {
        dictDefaultMessage: '<br>Clicca qui per caricare una foto o un allegato',
        dictCancelUpload: 'Cancel upload',
        dictCancelUploadConfirmation: 'Are you sure you want to cancel this upload?',
        dictFallbackMessage: 'Your browser does not support drag and drop file uploads.',
        dictFallbackText: 'Please use the fallback form below to upload your files like in the olden days.',
        dictFileTooBig: 'File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.',
        dictInvalidFileType: `You can't upload files of this type.`,
        dictMaxFilesExceeded: 'You can not upload any more files. (max: {{maxFiles}})',
        dictRemoveFile: 'Remove',
        dictRemoveFileConfirmation: null,
        dictResponseError: 'Server responded with {{statusCode}} code.',
      }
    },
  }) readonly language: any
  @Prop({
    type: Boolean,
    default: false,
  }) readonly useCustomDropzoneOptions!: boolean
  @Prop({
    type: Object,
  }) readonly dropzoneOptions!: Dropzone.DropzoneOptions

  public dropzone!: Dropzone

  public get cloudIcon() {
    if (this.useFontAwesome) {
      return '<i class="fa fa-cloud-upload"></i>'
    } else {
        return '<i class="mdi mdi-cloud-upload"></i>'
    }
  }

  public get doneIcon() {
    if (this.useFontAwesome) {
      return '<i class="fa fa-check"></i>'
    } else {
      return ' <i class="material-icons">done</i>'
    }
  }

  public get errorIcon() {
    if (this.useFontAwesome) {
      return '<i class="fa fa-close"></i>'
    } else {
      return ' <i class="material-icons">error</i>'
    }
  }

  protected mounted() {
    if (this.$isServer) {
      return
    }
    const Dropzone = require('dropzone')
    Dropzone.autoDiscover = false
    const ref = this.$refs['dz-el']
    if (this.useCustomDropzoneOptions) {
      this.dropzone = new Dropzone(ref, this.dropzoneOptions)
    } else {
      this.dropzone = new Dropzone(ref, {
        clickable: this.clickable,
        thumbnailWidth: this.thumbnailWidth,
        thumbnailHeight: this.thumbnailHeight,
        maxFiles: this.maxNumberOfFiles,
        maxFilesize: this.maxFileSizeInMB,
        addRemoveLinks: this.showRemoveLink,
        acceptedFiles: this.acceptedFileTypes,
        autoProcessQueue: this.autoProcessQueue,
        headers: this.headers,
        // language=HTML
        previewTemplate:
          `<div class="dz-preview dz-file-preview">
            <div class="dz-image" style="width:${this.thumbnailWidth}px;height:${this.thumbnailHeight}px">
              <img data-dz-thumbnail />
            </div>
            <div class="dz-details">
              <div class="dz-size"><span data-dz-size></span></div>
              <div class="dz-filename"><span data-dz-name></span></div>
            </div>
            <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            <div class="dz-error-message"><span data-dz-errormessage></span></div>
            <div class="dz-success-mark">${this.doneIcon}</div><div class="dz-error-mark">${this.errorIcon}</div>
          </div>`,
        dictDefaultMessage: this.cloudIcon + this.language.dictDefaultMessage,
        dictCancelUpload: this.language.dictCancelUpload,
        dictCancelUploadConfirmation: this.language.dictCancelUploadConfirmation,
        dictFallbackMessage: this.language.dictFallbackMessage,
        dictFallbackText: this.language.dictFallbackText,
        dictFileTooBig: this.language.dictFileTooBig,
        dictInvalidFileType: this.language.dictInvalidFileType,
        dictMaxFilesExceeded: this.language.dictMaxFilesExceeded,
        dictRemoveFile: this.language.dictRemoveFile,
        dictRemoveFileConfirmation: this.language.dictRemoveFileConfirmation,
        dictResponseError: this.language.dictResponseError,
        capture: 'camera',
      })
    }
    // Handle the dropzone events
    this.dropzone.on('thumbnail', (file) => {
      this.$emit('vdropzone-thumbnail', file)
    })
    this.dropzone.on('addedfile', (file) => {
      this.$emit('vdropzone-file-added', file)
    })
    this.dropzone.on('removedfile', (file) => {
      this.$emit('vdropzone-removed-file', file)
    })
    this.dropzone.on('success', (file, response) => {
      this.$emit('vdropzone-success', file, response)
    })
    this.dropzone.on('successmultiple', (files: Dropzone.DropzoneFile[]) => {
      this.$emit('vdropzone-success-multiple', files)
    })
    this.dropzone.on('error', (file: Dropzone.DropzoneFile, message: string | Error) => {
      this.$emit('vdropzone-error', file, message)
    })
    this.dropzone.on('sending', (file, xhr, formData) => {
      this.$emit('vdropzone-sending', file, xhr, formData)
    })
    this.dropzone.on('sendingmultiple', (file, xhr, formData) => {
      this.$emit('vdropzone-sending-multiple', file, xhr, formData)
    })
    this.dropzone.on('queuecomplete', (file, xhr, formData) => {
      this.$emit('vdropzone-queue-complete', file, xhr, formData)
    })
  }

  protected beforeDestroy() {
    this.dropzone.destroy()
  }
}
